/* =================== BUSCA CIDADES ESTADOS =================== */
jQuery(document).ready(function ($) { 

    $.ajaxSetup({ cache: false });

    // Função que carrega as cidades de um estado
    function carregaCidades() {
        var estado_id = $('#busca_estado').val();
        if (estado_id) {
            var url = $('#busca_cidade').data('url');
            var cidade_edit = $('#busca_cidade').data('cidade');
            $.ajax({
                url: url+"?estado_id="+estado_id,
                type: 'GET',
                dataType: 'json',
                crossDomain: true,
                success: function (data) {
                    var cidades = data;
                    if (cidades.length > 0) {
                        $('#busca_cidade').html('');
                        $('#busca_cidade').append('<option value="" hidden>Cidade</option>');
                        $('#busca_cidade').append('<option value="">Todas</option>');
                        for (var i = 0, n = cidades.length; i < n; i++) {
                            var cidade = cidades[i];
                            if (cidade.id == cidade_edit) {
                                $('#busca_cidade').append('<option value="' + cidade.id + '" selected>' + cidade.titulo + '</option>');
                            } else {
                                $('#busca_cidade').append('<option value="' + cidade.id + '">' + cidade.titulo + '</option>');
                            }
                        }
                    }
                }
            });

            /*var url = $('#busca_cidade').data('url');
            var cidade_edit = $('#busca_cidade').data('cidade');
            $.getJSON(url+"?estado_id="+estado_id, function (data) {
                cidades = data;
                if (cidades.length > 0) {
                    $('#busca_cidade').html('');
                    $('#busca_cidade').append('<option value="" hidden>Cidade</option>');
                    $('#busca_cidade').append('<option value="">Todas</option>');
                    for (var i = 0, n = cidades.length; i < n; i++) {
                        cidade = cidades[i];
                        if (cidade.id == cidade_edit) {
                            $('#busca_cidade').append('<option value="' + cidade.id + '" selected>' + cidade.titulo + '</option>');
                        } else {
                            $('#busca_cidade').append('<option value="' + cidade.id + '">' + cidade.titulo + '</option>');
                        }
                    }
                }
            });*/


        }
    }

    // Carrega automaticamente ao editar
    carregaCidades();

    // Evento ao alterar um estado
    $('#busca_estado').on('change', function () {
        carregaCidades();
    });

});

/* =================== ENVIA CONTATO =================== 
jQuery(document).ready(function($){
  var enviando_formulario = false;
  $('#form-representante').on('submit', function(e) {
    e.preventDefault(); 

    var obj = this;   
    var form = $(obj);
    var submit_btn = form.find('#enviar');            
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);    

    function volta_submit() {
      submit_btn.attr('disabled', false);            
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();           
    }

    if (!enviando_formulario) {              
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,    
        beforeSend: function() {  
          showLoading();                  
          enviando_formulario = true;                   
          submit_btn.attr('disabled', true);
          submit_btn.text('Enviando...');                    
        },           
        success: function(data){
          console.log(data);
          volta_submit();
          if (data == "ok") {
            $('#form-representante .campo').val('');
            showAlert('Sucesso', 'Sua mensagem foi enviada com sucesso.', 'success');
          } else {
            showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');
          }
        },
        error: function(xhr, type, exception) {  
          volta_submit();  
          showAlert('Erro', 'Não foi possível enviar a mensagem.', 'error');             
          console.log("ajax error response type "+type);
        }
      });
    }
  });
});
*/